import React from 'react'

import WebinarSidebarSeparator from '../../../sharedLegacy/features/WebinarSidebarFeature/components/WebinarSidebarSeparator/WebinarSidebarSeparator'
import useFeatures from '../../../sharedLegacy/hooks/useFeatures'
import { useCanInteractWithChat } from '../../blocs/chatVisibility'
import { ChatForm } from '../ChatForm/ChatForm'
import { ChatMessages } from '../ChatMessages/ChatMessages'
import { useIsLocalGuestSpeaker } from '../../../Speakers/blocs/useSpeakers'
import { Reply } from '../Reply/Reply'

import './Chat.scss'

const Chat = () => {
  const { HasSpeakerChatEnabled } = useFeatures()
  const isLocalGuestSpeaker = useIsLocalGuestSpeaker()

  const showChatForm = useCanInteractWithChat()

  return (
    // styled as flex column-reverse for accessibility reasons
    <div className="webinar-chat">
      {showChatForm && (
        <>
          <ChatForm />
          <Reply />
          <WebinarSidebarSeparator />
        </>
      )}

      {!isLocalGuestSpeaker && HasSpeakerChatEnabled && (
        <ChatMessages type="speaker-chat" />
      )}

      <ChatMessages type="chat" />
    </div>
  )
}

export { Chat }
